import { render, staticRenderFns } from "./employmentList.vue?vue&type=template&id=24fbcf15&"
import script from "./employmentList.vue?vue&type=script&lang=js&"
export * from "./employmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports